import { render, staticRenderFns } from "./configGrouptwo.vue?vue&type=template&id=3a628e02&scoped=true"
import script from "./configGrouptwo.vue?vue&type=script&lang=js"
export * from "./configGrouptwo.vue?vue&type=script&lang=js"
import style0 from "./configGrouptwo.vue?vue&type=style&index=0&id=3a628e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a628e02",
  null
  
)

export default component.exports